export default (container) => {
  /**
   * Add an empty iframe to given the container
   * and return a reference to said iframe.
   *
   * The created iframe fills the container,
   * has no borders, margin or padding.
   */
  const iframe = document.createElement('iframe')

  // no borders, full width and height
  iframe.style.border = 0
  iframe.style.width = iframe.style.height = '100%'

  container.appendChild(iframe)

  const doc = iframe.contentDocument

  // create an empty html5 document (this is required for Firefox)
  doc.open()
  doc.write('<!doctype html>')
  doc.close()

  // full height and no padding or margins on html and body
  doc.documentElement.style.height = doc.body.style.height = '100%'
  doc.documentElement.style.margin =
    doc.documentElement.style.padding =
    doc.body.style.margin =
    doc.body.style.padding =
      0

  return iframe
}
